import React, { useState, useEffect, useContext } from "react";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import update from "immutability-helper";
import styled from "styled-components";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  CLIENT_TERM_TEMPLATE_LIST_QUERY,
  DELETE_TERM_TEMPLATE_MUTATION,
} from "../../graphQL/term_template_qry";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import AlertDialog from "../../components/AlertDialog.js";

import AddTermTemplateInputDialog from "../../components/AddTermTemplateInputDialog.js";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    //  paddingTop:theme.spacing(2),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },

  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    // "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
    //   position: "relative",
    //   display: "block",
    // },
    "&.MuiDataGrid-root": {
      //paddingTop:10,
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ManageTermTemplates() {
  //const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [loadList, setLoadList] = useState(false);

  const [pageSize, setPageSize] = useState(20);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [termTemplateData, setTermTemplateData] = useState([]);

  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [addTermTemplateInputDialog, setAddTermTemplateInputDialog] = useState(false);
  const [alertDoneMsg, setAlertDoneMsg] = useState([]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  if (clientId == 0)
    loadData = false;

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Term Templates"     
            },
          });
    console.log('accessData.staffModuleAccess',accessData.staffModuleAccess)
    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      console.log('commonActions',commonActions)
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  } 

 useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  }; 

  
  const [getClientTermTemplateData] = useManualQuery(CLIENT_TERM_TEMPLATE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [deleteTemplateMutation] = useMutation(DELETE_TERM_TEMPLATE_MUTATION, {
    fetchPolicy: "network-only",
  });

  const tenantName = localStorage.getItem("tenantName");
    
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  const deleteTemplate = async termTemplateUuid => {
    setLoadList(false);
    const {
      loading: loadingTemplateDelete,
      error: errorTemplateDelete,
      data: dataTemplateDelete,
    } = await deleteTemplateMutation({
      variables: {
        termTemplateUuid: termTemplateUuid,
      },
    });
    if (
      !loadingTemplateDelete &&
      dataTemplateDelete &&
      dataTemplateDelete.deleteTermTemplate
    ) {
      setLoadList(true);
    }
    if (errorTemplateDelete) {
      if (errorTemplateDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorTemplateDelete.graphQLErrors[0].message);
    }
  };

  const getTermTemplateList = async () => {
    // Get term template list
    const {
      loading: termTemplateDataLoading,
      error: termTemplateDataError,
      data: termTemplateData,
    } = await getClientTermTemplateData({
      variables: {
        clientId: parseInt(clientId),
        showAllForList: true,
      },
    });

    if (
      !termTemplateDataLoading &&
      termTemplateData &&
      termTemplateData.clientTermTemplateList
    ) {
      setTermTemplateData(termTemplateData.clientTermTemplateList);

      loadData = true;
      setLoadList(false);
      setAddTermTemplateInputDialog(false);
    }
    else 
      loadData = false;

    if (
      termTemplateDataError &&
      termTemplateDataError.graphQLErrors &&
      termTemplateDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
    console.log("termTemplateData", termTemplateData);
  };

  const rows = termTemplateData.map(termTemplate => ({
    // index: termTemplate.termTemplateId,
    index: termTemplate.termTemplateUuid,
    name: termTemplate.name,
    noOfSeats: termTemplate.noOfSeats,
    noOfWeeks: termTemplate.noOfWeeks,
    noOfPeriods: termTemplate.noOfPeriods,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermTemplateList())();
  }, [loadList]);

  const columns = [
    {
      field: "index",
      headerName: "Template Uuid",
      minWidth: 10,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },

    {
      field: "name",
      headerName: "Template Name",
      minWidth: 80,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "noOfSeats",
      headerName: "No. of Seats",
      minWidth: 10,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "noOfPeriods",
      headerName: "No of Periods",
      minWidth: 10,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "noOfWeeks",
      headerName: "No of Weeks",
      minWidth: 10,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 50,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Edit">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() => rows.row.editAccess ?
                (
                    navigate(`${project_url}/tenant/settings/term_templates/` + rows.row.index)
                 )
                :""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Delete">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() =>
                  rows.row.deleteAccess ?
                  (
                    setAlertDeleteMsg({
                      title: "Delete Term Template",
                      type: "deleteConfirmation",
                      msg:
                        'Are you sure you want to delete the template "' +
                        rows.row.name +
                        '"?',
                      termTemplateUuid: rows.row.index,
                    })
                  )
                  :""
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const classes = useStyles();
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="body1">Manage Term Template</Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() => addAccess ? setAddTermTemplateInputDialog(true) : ""}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent)
    if (loadData)
    if (access)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            { label: "Manage Term Templates", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mb={3} />
          <PersistentDataGrid
            persistenceKey="manage-term-templates"
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            getRowId={row => row.index}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
          />

          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteTemplate(alertDeleteMsg.termTemplateUuid);
              }}
            />
          )}

          {addTermTemplateInputDialog && (
            <AddTermTemplateInputDialog closeDialog={() => getTermTemplateList()} />
          )}

          {alertDoneMsg.msg && (
            <AlertDialog
              title={alertDoneMsg.title}
              contentMsg={alertDoneMsg.msg}
              closeDialog={() => navigate(`${project_url}/tenant/dashboard`)}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Client"
                contentMsg='There is no client in this Tenant. Please create a client.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ManageTermTemplates;
